<template lang="pug">
	.card
		.card-header.bg-info.text-white
			span.fa.fa-search.mr-2
			| Búsqueda
		.card-body
			.row
				.col
					.form-group
						label Evento
						select.form-control(v-model="filtro.EventoID", @change="getGrupos")
							option(:value="null") Selecciona
							option(
								v-for="evento in listadoEventos"
								:key="evento.EventoID"
								:value="evento.EventoID"
							) {{evento.Nombre}}
				.col
					.form-group
						label Grupo
						select.form-control(v-model="filtro.GrupoID", @change="$emit('buscar')")
							option(:value="null") Selecciona
							option(
								v-for="grupo in listadoGrupos"
								:key="grupo.GrupoID"
								:value="grupo.GrupoID"
							) {{grupo.Nombre}}
				.col
					.form-group
						label Nombre
						input.form-control(placeholder="Buscar por nombre", v-model="filtro.Nombre", @keypress.enter="$emit('buscar')")
					div
						.form-group
							label Localización
							br
							.input-group.input-group-sm
								.input-group-prepend
									.input-group-text F
								input.form-control(placeholder="Fila", v-model="filtro.Fila", @keypress.enter="$emit('buscar')")
								.input-group-append
									.input-group-text A
								input.form-control(placeholder="Asiento", v-model="filtro.Asiento", @keypress.enter="$emit('buscar')")

				.col
					.form-group
						label Usuario que gestiona
						input.form-control(placeholder="Nombre del usuario", v-model="filtro.Usuario", @keypress.enter="$emit('buscar')")
					div
						.form-group
							label Estado localización
							br
							.btn-group
								button.btn.btn-sm(:class="filtro.Localizacion === null ? 'btn-primary' : 'btn-default'", @click="setLocalizacion(null)") Todos
								button.btn.btn-sm(:class="filtro.Localizacion === 'Con' ? 'btn-primary' : 'btn-default'", @click="setLocalizacion('Con')") Asignada
								button.btn.btn-sm(:class="filtro.Localizacion === 'Sin' ? 'btn-primary' : 'btn-default'", @click="setLocalizacion('Sin')") Sin asignar

				.col
					.form-group
						label Categoria
						br
						.btn-group
							button.btn(:class="(filtro.VIP === null) ? 'btn-primary' : ''", @click="setVIP(null)") Todos
							button.btn(:class="(filtro.VIP === true) ? 'btn-warning' : ''", @click="setVIP(true)") VIP
							button.btn(:class="(filtro.VIP === false) ? 'btn-danger' : ''", @click="setVIP(false)") No VIP

				.col
					.form-group
						label Estado
						br
						.btn-group
							button.btn(:class="(filtro.Estados['No Avisado']) ? 'btn-primary' : ''", @click="toggleEstado('No Avisado')") No avisado
							button.btn(:class="(filtro.Estados.Pendiente) ? 'btn-primary' : ''", @click="toggleEstado('Pendiente')") Pendiente
							button.btn(:class="(filtro.Estados.Entregado) ? 'btn-primary' : ''", @click="toggleEstado('Entregado')") Entregada
							button.btn(:class="(filtro.Estados.Confirmado) ? 'btn-primary' : ''", @click="toggleEstado('Confirmado')") Confirmado
							button.btn(:class="(filtro.Estados.Denegado) ? 'btn-primary' : ''", @click="toggleEstado('Denegado')") Denegado
		.card-footer
			button.btn.btn-primary.mr-2(@click="$emit('buscar')") Buscar
			button.btn.btn-success.mr-2(@click="$emit('nuevo')")
				span.fa.fa-user.mr-2
				| Nuevo invitado
			button.btn.btn-warning(v-if="filtro.EventoID", @click="verRecinto")
				span.fa.fa-eye.mr-2
				| Ver recinto
		VerRecinto(v-if="RecintoEventoID", :EventoID="RecintoEventoID", @cerrar="RecintoEventoID = null")
</template>

<script>
import API from '../../api'
import VerRecinto from '../editor/verRecinto'
import { mapGetters } from 'vuex'
export default {
	props: ['filtro'],
	components: {
		VerRecinto
	},
	data () {
		return {
			RecintoEventoID: null,
			listadoEventos: [],
			listadoGrupos: [],
			editar: null
		}
	},
	created () {
		API.getEventos()
			.then(res => {
				this.listadoEventos = res.data
				if (this.listadoEventos.length === 1) {
					this.filtro.EventoID = this.listadoEventos[0].EventoID
					this.getGrupos()
				}
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario'
		})
	},
	methods: {
		buscar () {
			this.$emit('buscar')
		},
		setLocalizacion (estado) {
			this.filtro.Localizacion = estado
			this.buscar()
		},
		toggleEstado (estado) {
			this.filtro.Estados[estado] = !this.filtro.Estados[estado]
			this.buscar()
		},
		setVIP (value) {
			this.filtro.VIP = value
			this.buscar()
		},
		verRecinto () {
			this.RecintoEventoID = parseInt(this.filtro.EventoID)
		},
		getGrupos () {
			if (!this.filtro.EventoID) {
				this.listadoGrupos = []
				this.filtro.GrupoID = null
				return
			}
			API.getGrupos(this.filtro.EventoID)
				.then(res => {
					this.listadoGrupos = res.data
					this.buscar()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/invitaciones/vue/components/buscador/filtro.vue